// Le hero : un vrai ciel du matin en fond (public/media/hero-sky.jpg, généré
// pour le site), le titre centré, un seul bouton, et le film posé dessous dans
// un cadre de verre clair qui déborde sur la section suivante.
import { Link } from 'react-router-dom'
import Film from './Film'
import { Apple, Windows, Phone, Check } from './Icons'
import { useT } from '../../lib/i18n'

const PUB = process.env.PUBLIC_URL || ''
const SKY = { '--sky': `url(${PUB}/media/hero-sky.jpg)`, '--sky-m': `url(${PUB}/media/hero-sky-m.jpg)` }

export default function Hero () {
  const h = useT().hero

  return (
    <section className="lp-hero">
      <div className="lp-hero__sky" aria-hidden="true" style={SKY} />
      <div className="lp-wrap lp-hero__in">
        <span className="lp-clock">
          <b>{h.clock.slice(0, 2)}<em>:</em>{h.clock.slice(3)}</b>
          <span>{h.clockL}</span>
        </span>

        <h1 className="lp-h1">
          {h.t1} {h.t2} <em>{h.t3}</em>
          <br />{h.t4}
        </h1>

        <p className="lp-hero__lead">{h.lead}</p>

        <div className="lp-hero__cta">
          <Link to="/register" className="lp-btn lp-btn--main lp-btn--lg">{h.cta} <span aria-hidden="true">→</span></Link>
          <a href="#pricing" className="lp-btn lp-btn--glass lp-btn--lg">{h.ctaAlt}</a>
        </div>

        <ul className="lp-hero__meta">
          {h.meta.map(m => <li key={m}><Check />{m}</li>)}
        </ul>

        <div className="lp-hero__works">
          <span>{h.works}</span>
          <span className="lp-hero__os"><Phone />iPhone</span>
          <span className="lp-hero__os"><Phone />iPad</span>
          <span className="lp-hero__os"><Apple />Mac</span>
          <span className="lp-hero__os"><Windows />Windows</span>
        </div>

        <div className="lp-hero__film" id="film">
          <img className="lp-hero__lock" src={`${PUB}/media/glass-lock.webp`} alt="" aria-hidden="true" width="720" height="720" />
          <img className="lp-hero__sun" src={`${PUB}/media/dot-sun.webp`} alt="" aria-hidden="true" width="360" height="360" />
          <Film />
        </div>

      </div>
    </section>
  )
}
